var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui negative message small"},_vm._l((_vm.localisedErrors),function(error){return _c('div',{key:error,domProps:{"innerHTML":_vm._s(error)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }